<div class="fc-header-wrapper">
  <h1 class="fc-brand-title">
    <a href="/"><span class="fcLoginFraud">File</span><span>Capture</span><sup class="fc-brand-sup">&#174;</sup></a>
  </h1>
  @if (headerEnabled && headerText) {
    <div class="fc-brand-subtitle" [innerHTML]="headerHtml" ></div>
  }
</div>
<hr class="fc-header-divider">
